<tr @click="openFolder" class="cursor-pointer">

  <!-- 1. Select checkbox -->
  <td class="text-center"></td>

  <!-- 2. Icon -->
  <td class="text-center">
    <img src="@/assets/images/folder.png" class="w-20px" alt="">
  </td>

  <!-- 3. Name -->
  <td class="text-xxs text-dark">
    {{ folder.folder_name }}
  </td>

  <!-- 4. Created -->
  <td class="text-xxs text-dark">
    {{ folder.date_created }}
  </td>

  <!-- 5. Approved by (hidden to match header) -->
  <td class="d-none"></td>

  <!-- 6. Actions -->
  <td>
    <div class="d-flex">
      <button
        v-if="can_delete && folder.folder_name !== 'Approvals'"
        class="btn btn-danger btn-sm text-xxs rounded"
        @click.stop="delete_folder(folder.id)"

      >
        Delete
      </button>
    </div>
  </td>

  <!-- 7. Spacer column -->
  <td></td>

</tr>



<!-- Manage Permissions Modal -->
<div class="modal fade" :id="'manage_folder_permissions_modal' + folder.id" tabindex="-1" aria-labelledby="manageFolderPermissionsModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title text-xs fw-500">Manage Permissions </h5>
        <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal"></button>
      </div>

      <div class="modal-body modal-body-scroll">
        <!-- Add User -->
        <input type="text" v-model="searchQuery" @input="searchUsers" placeholder="Search users by name or email" class="form-control mb-2" />

<!-- Current Permissions -->
<div v-for="user in filteredPortalMembers" :key="user.portal_access.id" class="d-flex align-items-center mb-2">
  <div class="me-2">
    <strong>{{ user.portal_access.user.first_name }} {{ user.portal_access.user.last_name }} </strong>
    <br><small>{{ user.portal_access.user.email }}</small>
    <span v-if="user.is_owner"> (Owner)</span>
  </div>

  <div class="form-check ms-auto me-2">
  </div>
  <div class="form-check me-2">
    <input class="form-check-input" type="checkbox" v-model="user.create" :disabled="user.is_owner"> Create
  </div>

  <div class="form-check me-2">
    <input class="form-check-input" type="checkbox" v-model="user.delete" :disabled="user.is_owner"> Delete
  </div>

</div>

      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-primary text-xs rounded-5" @click="save_folder_permissions">Save Changes</button>
      </div>
    </div>
  </div>
</div>
